export class MemberPlanOperation {
    public HealthNetworkPlanCode: string;
    public IsNetworkChangeAllowed: boolean;
    public IsProviderChangeAllowed: boolean;
    public IsUserSelectable: boolean;
}
